module.exports = __webpack_public_path__ + "static/media/avatar-foot.31b58bb0.svg";